import { gql } from '__generated__'

export const GetColleges = gql(/* GraphQL */ `
    query GetColleges {
        colleges {
            id
            value
        }
    }
`)
